// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { capabilities, checkNameAvailability } from "./operations.js";
export {
  RecoveryServicesCapabilitiesOptionalParams,
  RecoveryServicesCheckNameAvailabilityOptionalParams,
} from "./options.js";
